import React, { useState, useContext, useEffect } from "react";
import AmountCmp from "../../../component/AmountCmp/amountCmp";
import { getSectionAndComponentGroup, getSectionData } from "../../../helper/strapi";
import FDJourneyContext from "../../../stateManagement/fdJourney/context";
import ButtonCmp from "../../../component/ButtonCmp";
import PageStateContext from "../../../stateManagement/pageState/context";
import JourneyStateContext from "../../../stateManagement/journeyState/context";
import SectionStateContext from "../../../stateManagement/sectionState/context";
import { journeyUpdateSectionCheck, validateInsurance } from "../../../service/api_service";
import ModalCmp from "../../../component/ModalCmp";
import { ModalMessage } from "../../../service/modalMessage";
import { pageNameList, sectionNameList, cleverTapEventList, productList, paymentStatus, additionalCleverTap, staticProperties } from "../../../service/commonService";
import { apiFormGeneration, changeNextRoute, changePrevRoute, componentRenderCheck, saveSectionState, getGenuineCmpCount, savePageState, getSectionStateData, generateInsurancePayload, getErrorLookup, cleverTapInit,getAgeFromDobInYrs } from '../../../helper/common';
import { useRouter } from "next/router";
import ConditionContext from "../../../stateManagement/Condition/context";
import StaticTextCmp from "../../../component/StaticTextCmp";
import DigiCashVarStateContext from "../../../stateManagement/DigiCashVarState/context";

export default function DebitCardFunds() {
    const fdJourneyContext = useContext(FDJourneyContext);
    const pageStateContext = useContext(PageStateContext);
    const journeyStateContext = useContext(JourneyStateContext);
    const sectionStateContext = useContext(SectionStateContext);
    const conditionStateContext = useContext(ConditionContext);
    const digiCashVarStateContext = useContext(DigiCashVarStateContext);
    const { conditionState, setConditionState } = conditionStateContext
    const { sectionState, setSectionState } = sectionStateContext
    const { pageState, setPageState } = pageStateContext
    const { journeyState, setJourneyState } = journeyStateContext
    const { heading: modalHeading, message: modalMessage, action: modalAction, image: modalImage, icon: modalIcon } = ModalMessage
    const { pages, currentSection, setCurrentSection, currentPage, setCurrentPage, forwardJourney, 
        setForwardJourney, journeyId, setJourneyId, mobileNo, setMobileNo, strapiPagesAndSectionLookup, 
        journey, setJourney, sourceId, lookup, locationVar } = fdJourneyContext;

    const {staticDataObject, dynamicDataObject, setDynamicDataObject, eventDataObject, resetDynamicData, 
        resetEventData } = digiCashVarStateContext

    const [sliderBlur, setSliderBlur] = useState(false)
    const [silderData, setSilderData] = useState("");
    const [sectionRenderCheck, setSectionRenderCheck] = useState(false);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [paymentUrl, setPaymentUrl] = useState("")
    const [disabledContinueButton, setDisabledContinueButton] = useState(false)
    let dataAvailable = false;
    const router = useRouter()
    const sectionData = getSectionData(pages && pages[currentPage['currentPage']]);
    const [savedSectionState, setSavedSectionState] = useState({})
    const [formData, setFormData] = useState([]);
    const [readOnlyInputs, setReadOnlyInputs] = useState(true)
    const [insuranceOptCheck, setInsuranceOptCheck] = useState(false)
    const [modalData, setModalData] = useState({ error: "", image: "", icon: "", iconText: "", errorText: "", button: "", exit: "" })
    const insuranceDetails = Object.keys(lookup).length && lookup?.insuranceDetail.hasOwnProperty(journey) ? lookup?.insuranceDetail[journey] : []
    const { sectionAttribute, componentGroupData } = getSectionAndComponentGroup(sectionData && sectionData[currentSection['currentSection']]);
    if (componentGroupData && sectionRenderCheck) {
        dataAvailable = true;
    }
    const { clevertapLookup: { ["common"]: { "INSURANCE": cleverTapPayload } } } = lookup;  
    const { clevertapLookup : { common: { commonEvent: additionalCleverTapPayload } } } = lookup;
    const cleverTapEventName = cleverTapEventList(sourceId)[currentSection["currentSectionName"]]["INSURANCE"]

    const [apiCall, setApiCall] = useState(false)

    const setValueInSlider = (value) => {
        setSilderData({ setIntoSlider: value, getFromSlider: silderData.getFromSlider });
    }
    const [insuranceBlock, setInsuranceBlock] = useState(false)

    useEffect(() => {
        const tempSavedSectionState = getSectionStateData(pageState, journeyState, strapiPagesAndSectionLookup, currentSection["currentSectionName"])
        if (journey === productList(sourceId).WOMANIA) {
            const savedPreviousSectionState = getSectionStateData(pageState, journeyState, strapiPagesAndSectionLookup, sectionNameList(sourceId).WOMANIA_ADD_FUND)
            setSavedSectionState({ fundAccountAmount: savedPreviousSectionState["addFundAmount"] ? savedPreviousSectionState["addFundAmount"] : lookup["debitCards"][journey][conditionState["debitCardSelection"] ?? staticProperties().NOT_APPLICABLE]["amount"], debitCardAmount: conditionState["debitCardChoice"] === "Y" ? lookup["debitCards"][journey][conditionState["debitCardSelection"] ?? staticProperties().NOT_APPLICABLE]["total"] : "", fundAccountTotalAmount: conditionState["debitCardChoice"] === "Y" ? String(Number(savedPreviousSectionState["addFundAmount"]) + Number(lookup["debitCards"][journey][conditionState["debitCardSelection"] ?? staticProperties().NOT_APPLICABLE]["total"])) : savedPreviousSectionState["addFundAmount"] })
        }
        else {
            const savedPreviousSectionState = getSectionStateData(pageState, journeyState, strapiPagesAndSectionLookup, sectionNameList(sourceId).CC_ADD_FUND)
            const personalDetailSavedSectionState = getSectionStateData(pageState, journeyState, strapiPagesAndSectionLookup, sectionNameList(sourceId).KYC_PERSONAL_DETAIL);
            if (personalDetailSavedSectionState && Object.keys(personalDetailSavedSectionState).length) {
                if (Number(getAgeFromDobInYrs(personalDetailSavedSectionState["dob"])) <= 65) {
                    setInsuranceOptCheck(true)
                }
            }
            setSavedSectionState({ fundAccountAmount: savedPreviousSectionState["addFundAmount"] ? savedPreviousSectionState["addFundAmount"] : lookup["debitCards"][journey][conditionState["debitCardSelection"]]["amount"], debitCardAmount: conditionState["debitCardChoice"] === "Y" ? lookup["debitCards"][journey][conditionState["debitCardSelection"]]["total"] : "", fundAccountTotalAmount: conditionState["debitCardChoice"] === "Y" ? String(Number(savedPreviousSectionState["addFundAmount"]) + Number(lookup["debitCards"][journey][conditionState["debitCardSelection"]]["total"]) + Number(tempSavedSectionState["insuranceTakenCount"] ? Number(insuranceDetails[0].amount) : 0)) : Number(savedPreviousSectionState["addFundAmount"]) + Number(tempSavedSectionState["insuranceTakenCount"] ? Number(insuranceDetails[0].amount) : 0) })
            if(tempSavedSectionState){
                setInsuranceBlock(tempSavedSectionState["insuranceTakenCount"])
            }
        }
    }, [pageState])

    useEffect(() => {
        setDynamicDataObject((prevState) => ({
            ...prevState, "firstSeen": Date.now(),
          }))

        window.scrollTo(0, 0)
        const updateJourneyPayload = {
            "journeyId": journeyId,
            "page": currentPage["currentPageName"],
            "section": currentSection["currentSectionName"],
            "source": sourceId,
            "product": journey
        }
        journeyUpdateWrapper(updateJourneyPayload);

        return () => {
            resetDynamicData()
            resetEventData()
        }
    }, [])

    // call create order api
    const handleValidateNow = async () => {
        const tempJsonForm = apiFormGeneration(formData)
        tempJsonForm["insuranceTakenCount"] = insuranceBlock
        if (!Number(tempJsonForm["fundAccountTotalAmount"])) {
            router.push(process.env.DSA_SUCCESS_ROUTE)
        }
        else {
            // // function to save state of section
            saveSectionState(sectionState, setSectionState, currentSection["currentSectionName"], tempJsonForm)
            // // function to save state of page
            savePageState(sectionState, setSectionState, pageState, setPageState, tempJsonForm, currentSection["currentSectionName"], currentPage["currentPageName"])
            setForwardJourney(true)
            changeNextRoute(currentSection, setCurrentSection, currentPage, setCurrentPage, pages, strapiPagesAndSectionLookup);
        }
    }

    const journeyUpdateWrapper = async (payload) => {
        try {
            const { data } = await journeyUpdateSectionCheck(payload);
            if (data) {
            }
            return data;
        } catch (err) {
            return Promise.reject(err)
        }
    }

    const handleInsurance = async (val) => {  
        setApiCall(true) 
        Object.keys(cleverTapPayload).forEach((key) => cleverTapPayload[key]="")

        cleverTapPayload["product"] = journey
        cleverTapPayload["JourneyId"] = journeyId
        cleverTapPayload["I'll do it later"] = "N"
        cleverTapPayload["Add"] = "Y"
        cleverTapPayload["Click to view benefits"] = "Y"
        cleverTapPayload["Continue"] = "Y"

        const additionalCleverTapReturnPayload = additionalCleverTap(additionalCleverTapPayload, conditionState, locationVar, staticDataObject, dynamicDataObject, eventDataObject, journeyId, cleverTapEventName)       
        cleverTapInit(cleverTapEventName, { ...cleverTapPayload, ...additionalCleverTapReturnPayload}, journey)

        setSavedSectionState((prev) => ({
            ...prev,
            ["fundAccountAmount"]: String(Number(savedSectionState["fundAccountAmount"])),
            ["fundAccountTotalAmount"]: String(Number(savedSectionState["fundAccountTotalAmount"]) + val)
        }))
        setInsuranceBlock(true)
        const insurancePayload = generateInsurancePayload(insuranceDetails, true, journeyId, currentPage, currentSection, sourceId, journey, insuranceDetails.length)
        await validateInsurance(insurancePayload)
        setApiCall(false)
    }

    const removeInsurance = async (val) => {
        setApiCall(true)
        Object.keys(cleverTapPayload).forEach((key) => cleverTapPayload[key]="")

        cleverTapPayload["product"] = journey
        cleverTapPayload["JourneyId"] = journeyId
        cleverTapPayload["I'll do it later"] = "Y"
        cleverTapPayload["Add"] = "N"
        cleverTapPayload["Click to view benefits"] = "Y"
        cleverTapPayload["Continue"] = "Y"

        const additionalCleverTapReturnPayload = additionalCleverTap(additionalCleverTapPayload, conditionState, locationVar, staticDataObject, dynamicDataObject, eventDataObject, journeyId, cleverTapEventName)        
        cleverTapInit(cleverTapEventName, { ...cleverTapPayload, ...additionalCleverTapReturnPayload}, journey)

        setSavedSectionState((prev) => ({
            ...prev,
            ["fundAccountAmount"]: String(Number(savedSectionState["fundAccountAmount"])),
            ["fundAccountTotalAmount"]: String(Number(savedSectionState["fundAccountTotalAmount"]) - val)
        }))
        setInsuranceBlock(false)
        const insurancePayload = generateInsurancePayload(insuranceDetails, false, journeyId, currentPage, currentSection, sourceId, journey, insuranceDetails.length - 1)
        await validateInsurance(insurancePayload)
        setApiCall(false)
    }

    const getFormControlAndValue = (value, formControlKey, error = false) => {
        let formControlKeyAvailable = true;
        // Find if formCiontrol already available or not
        formData.map((data, index) => {
            // if available then patch the latest value
            if (formControlKey in data) {
                formControlKeyAvailable = false;
                setFormData(
                    [...formData].map((object) => {
                        if (Object.keys(object)[0] === formControlKey) {
                            object[formControlKey] = value;
                            object['error'] = error;
                            return object;
                        } else return object;
                    }),
                );
            }
        });
        // if not avialble then push the init value
        if (formControlKeyAvailable) {
            setFormData((prevState) => [
                ...prevState,
                { [formControlKey]: value, ['error']: error },
            ]);
        }
    };

    return (
        <div className="columns-1 common-joiningFees-layout  fundFD1 ">
            <div className="go-account-details">
                <div className="title-box">
                    <h4>Fund Your Account</h4>
                </div>
                <div className="left-info">
                    <div className="form-box">
                        <form>
                            <div className="form-field-row">
                                {componentGroupData?.map((item, index) => {
                                    const {
                                        attributes,
                                        attributes: { components },
                                    } = item;
                                    let componentData = components[0];
                                    switch (componentData.type) {
                                        case 'amount':
                                            return <AmountCmp readOnlyInputs={readOnlyInputs} savedSectionState={savedSectionState} attributes={attributes} getFormControlAndValue={getFormControlAndValue} sliderValue={silderData.getFromSlider} getAmountValue={setValueInSlider} sliderBlur={sliderBlur} setSliderBlur={setSliderBlur} key={index} cmpData={componentData}></AmountCmp>
                                            break;
                                        case 'button':
                                            return <ButtonCmp disabled={disabledContinueButton} handleValidateNow={handleValidateNow} attributes={attributes} key={index} cmpData={componentData} apiCall={apiCall}></ButtonCmp>
                                            break;
                                        case 'staticText':
                                            return <StaticTextCmp attributes={attributes} key={index} cmpData={componentData} handleInsurance={handleInsurance} removeInsurance={removeInsurance} insuranceBlock={insuranceBlock} insuranceOptCheck={insuranceOptCheck}></StaticTextCmp>
                                            break;
                                    }
                                })}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {openModal && <ModalCmp openModal={openModal} setOpenModal={setOpenModal} modalData={modalData} setApiCall={setApiCall}></ModalCmp>}
        </div>
    )
}